export const userActivityKeys = {
  fullswing: "fullswing",
  shortgame: "shortgame",
  putter: "putter",
  scan: "scan",
  bunker: "bunker",
  captures: "captures",
};

export const platformConversion: { [key: string]: string } = {
  desktop: "dc1",
  web: "web",
  android: "and",
  iOS: "iOS",
};

export const sportnames = {
  golf: "golf",
  baseball: "baseball",
};

export const DEVICE_TYPE_COUNT_COLORS: any = {
  ios: "#006AB3",
  android: "#FBB900",
  studio: "#78BA2C",
  web: "#1C1C1D",
};
